export const apiGermanLocalization = {
  mediaUpload: {
    error:
      'Hoppla, Das Dokument konnte nicht hochgeladen werden. Bitte versuche es später erneut.'
  },
  archiveChat: {
    error: 'Chat konnte nicht archiviert werden.'
  },
  unarchiveChat: {
    failed: 'Archivierung konnte nicht aufgehoben werden.'
  },
  deleteChatMessage: {
    error: 'Nachricht konnte nicht gelöscht werden.'
  },
  deletePost: {
    success: 'Funk erfolgreich gelöscht.',
    error: 'Funk konnte nicht gelöscht werden.'
  },
  createPost: {
    error: 'Funk konnte nicht erstellt werden. Bitte versuche es später erneut.'
  },
  announceHappeningParticipation: {
    error:
      'Teilnahme konnte nicht angekündigt werden. Bitte versuche es später erneut.'
  },
  revokeHappeningParticipation: {
    error:
      'Teilnahme konnte nicht zurückgezogen werden. Bitte versuche es später erneut.'
  },
  startChat: {
    error:
      'Chat konnte nicht gestartet werden. Bitte versuche es später erneut.',
    success: 'Chat gestartet.'
  },
  joinGroup: {
    success: 'Deine Beitrittsanfrage wurde verschickt.'
  },
  votePoll: {
    success: 'Vielen Dank für deine Teilnahme!'
  },
  resendVerificationEmail: {
    success: 'E-Mail verschickt!\nBitte schau in dein E-Mail-Postfach.'
  },
  organization: {
    updateSuccess: 'Organisation erfolgreich gespeichert.',
    createError: 'Organisation konnte nicht erstellt werden.',
    errorTaoAlreadyExists:
      'Eine Gebietskoerperschaft mit diesen Daten existiert bereits.',
    errorNameAlreadyExistsInGeoArea:
      'Es existiert bereits eine Organisation mit diesem Namen in einer der ausgewählten Regionen.',
    errorAdminNotFound: 'Der angegebene Administrator wurde nicht gefunden.',
    errorAdminNotVerified: 'Der Administrator ist noch nicht verifiziert.',
    errorTagNotAllowed: 'Dieser Organisationstyp ist nicht erlaubt.',
    errorGeoAreaNotInScope:
      'Die Geo-Einheit liegt nicht im zulaessigen Bereich.',
    errorNotAuthorized: 'Du bist nicht berechtigt, diese Aktion auszufuehren.'
  },
  error: 'Hoppla, etwas lief schief. Bitte versuche es später erneut.'
};

// Todo: Define exact type so that english does not include unnecessary keys
// Guarantees that both translations have the same structure
export type ApiLocalization = typeof apiGermanLocalization;

export const apiEnglishLocalization: ApiLocalization = {
  mediaUpload: {
    error: 'Oops, The document could not be uploaded. Please try again later.'
  },
  archiveChat: {
    error: 'Chat could not be archived.'
  },
  unarchiveChat: {
    failed: 'Chat could not be unarchived.'
  },
  deleteChatMessage: {
    error: 'Message could not be deleted.'
  },
  deletePost: {
    success: 'Post was successfully deleted.',
    error: 'Post could not be deleted.'
  },
  createPost: {
    error: 'The post could not be created. Please try again later.'
  },
  announceHappeningParticipation: {
    error: 'Participation could not be announced. Please try again later.'
  },
  revokeHappeningParticipation: {
    error: 'Participation could not be revoked. Please try again later.'
  },
  startChat: {
    error: 'Chat could not be started. Please try again later.',
    success: 'Chat gestartet.'
  },
  joinGroup: {
    success: 'Your join request has been sent.'
  },
  votePoll: {
    success: 'Thank you for your participation!'
  },
  resendVerificationEmail: {
    success: 'Resent email!\nFind it in your email inbox.'
  },
  organization: {
    updateSuccess: 'Organization saved successfully.',
    createError: 'Organization could not be created.',
    errorTaoAlreadyExists:
      'A territorial authority with these details already exists.',
    errorNameAlreadyExistsInGeoArea:
      'An organization with this name already exists in one of the selected regions.',
    errorAdminNotFound: 'The specified administrator was not found.',
    errorAdminNotVerified: 'The administrator is not verified yet.',
    errorTagNotAllowed: 'This organization type is not allowed.',
    errorGeoAreaNotInScope: 'The geo area is not within the allowed scope.',
    errorNotAuthorized: 'You are not authorized to perform this action.'
  },
  error: 'Oops, something went wrong. Please try again later.'
};
